import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/marketingToolsApi'
import { message, Modal } from 'hljd'

class Store {
  hot_tag
  ids
  count

  @observable checked = []

  @observable list = []
  @action
  getList = async page => {
    const { hot_tag, current } = this

    let params = {
      hot_tag,
      per_page: 15,
      page: page ? page : current
    }
    let {
      data: { list, total_count }
    } = await Api.tag_list(params)
    runInAction(() => {
      this.list = list || []
      this.total = +total_count
    })
  }

  @action
  doCheckTag = id => () => {
    const { checked, ids, count } = this

    if (checked.join().indexOf(id) == -1) {
      if (checked.length + 1 > ids.length + count) {
        return Modal.warning({
          title: '该标签下套餐数已达上限',
          content: '可取消已有套餐后再添加'
        })
      }

      checked.push(id)
    } else {
      for (let i = 0, len = checked.length; i < len; i++) {
        if (checked[i] == id) {
          checked.splice(i, 1)
        }
      }
    }
  }

  @action
  addTag = async () => {
    let { checked, hot_tag } = this

    let params = {
      setmeal_ids: checked.join(),
      type: 'add',
      hot_tag
    }

    let { success } = await Api.tag(params)
    if (success) {
      message.success('添加成功！')
      this.checked = []
      window.location.href = '#/localMerchant/marketingTools?key=17'
    }
  }

  @action
  reSet = async () => {
    let { checked, hot_tag } = this

    if (checked.length) {
      let params = {
        setmeal_ids: checked && checked.join(),
        type: 'delete',
        hot_tag
      }

      let { success } = await Api.tag(params)
      if (success) {
        message.success('取消成功！')
        this.checked = []
        window.location.href = '#/localMerchant/marketingTools?key=17'
      }
    }
  }

  @observable current = 1
  @observable total = 1
  @action
  setPage = page => {
    this.current = page
    this.getList(page)
  }
}
export default new Store()
